import { createContext, useContext, useState, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DataWellSlotContext = /*#__PURE__*/createContext(null);
export function DataWellSlotProvider({
  children
}) {
  const [hasDataWellSlot, setHasDataWellSlot] = useState(false);
  const value = useMemo(() => ({
    hasDataWellSlot,
    setHasDataWellSlot
  }), [hasDataWellSlot]);
  return /*#__PURE__*/_jsx(DataWellSlotContext.Provider, {
    value: value,
    children: children
  });
}
export function useHasDataWellSlot() {
  var _context$hasDataWellS;
  const context = useContext(DataWellSlotContext);
  return (_context$hasDataWellS = context === null || context === void 0 ? void 0 : context.hasDataWellSlot) !== null && _context$hasDataWellS !== void 0 ? _context$hasDataWellS : false;
}
export function useSetHasDataWellSlot() {
  var _context$setHasDataWe;
  const context = useContext(DataWellSlotContext);
  return (_context$setHasDataWe = context === null || context === void 0 ? void 0 : context.setHasDataWellSlot) !== null && _context$setHasDataWe !== void 0 ? _context$setHasDataWe : () => {};
}